import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import ROUTES from '../RouteConstants';
import useAuthTokenHandler from './useAuthTokenHandler';

const PublicRoute = () => {
  const { checkingAuth, isLoggedIn } = useAuthTokenHandler();

  useEffect(() => {
    if (!checkingAuth && !isLoggedIn) {
      const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
      const redirectUrl = process.env.REACT_APP_AUTH_REDIRECT_URL;
      window.location.href = `${apiBaseUrl}?continue=${encodeURIComponent(redirectUrl)}`;
    }
  }, [checkingAuth, isLoggedIn]);

  if (isLoggedIn && !checkingAuth) {
    return <Redirect to={ROUTES.DASHBOARD} />;
  }
  return null;
};

export default PublicRoute;
